import { OwnUpSmallBody } from '@rategravity/own-up-component-library';
import React from 'react';
import { WidgetWrapper } from '../common/WidgetWrapper';
import { MonthlyPaymentProvider } from './data/dataProvider';
import { Inputs } from './inputs';
import { CalculationSummary } from './summary';

const description = (
  <React.Fragment>
    <OwnUpSmallBody variant="body1">
      Monthly Payment Calculator: Effortlessly Estimate Your Loan Repayments
    </OwnUpSmallBody>
    <br />
    <OwnUpSmallBody variant="body1">
      Introducing our Monthly Payment Calculator – your go-to tool for simplifying the complex
      calculations of loan repayments. Whether you&apos;re planning to finance a new home, car, or
      any significant purchase, our calculator provides you with a clear breakdown of your monthly
      obligations. By inputting your loan amount, interest rate, and loan term, you&apos;ll
      instantly receive an accurate estimate of your monthly payment. This tool is designed to help
      you make informed financial decisions, allowing you to budget effectively and plan for the
      future with confidence. Use our Monthly Payment Calculator today to take the first step
      towards financial clarity and stability.{' '}
    </OwnUpSmallBody>
  </React.Fragment>
);

export const MonthlyPaymentCalculator: React.FC = () => {
  return (
    <WidgetWrapper title="Monthly payment Calculator" description={description}>
      <MonthlyPaymentProvider>
        <Inputs />
        <CalculationSummary />
      </MonthlyPaymentProvider>
    </WidgetWrapper>
  );
};
